import * as React from 'react';
import {
  FormControl,
  FormDescription,
  FormItem,
  FormLabel,
} from 'components/ui/form';
import { Switch } from 'components/ui/switch';
import { cn } from 'lib/utils';

type SwitchGsProps = {
  label: string;
  description?: string;
  onCheckedChange?(checked: boolean): void;
  checked?: boolean;
  className?: string;
};

export const SwitchGs = React.forwardRef<HTMLBaseElement, SwitchGsProps>(
  ({ label, onCheckedChange, checked, description, className }) => {
    return (
      <FormItem className={cn("flex flex-row items-center justify-between rounded-lg border p-4", className)}>
        <FormLabel className="text-sm font-sans">{label}</FormLabel>
        {description && <FormDescription>{description}</FormDescription>}
        <FormControl>
          <Switch
            checked={checked}
            onCheckedChange={onCheckedChange}
            className="scale-90 !m-0"
          />
        </FormControl>
      </FormItem>
    );
  }
);
